import { __assign, __extends } from "tslib";
import * as React from 'react';
import { BaseButton } from '@fluentui/react';
import { getInputMethodFromEvent, InputMethod, isIE } from '@ms/acui-common';
import { AppThemeConsumer } from '@ms/acui-theme';
import { getAppBaseButtonStyles } from './AppBaseButton.styles';
var AppBaseButton = /** @class */ (function (_super) {
    __extends(AppBaseButton, _super);
    function AppBaseButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.button = React.createRef();
        _this.pointerDownEventId = undefined;
        _this.pointerInputMethod = undefined;
        _this.openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
            if (_this.button.current) {
                _this.button.current.openMenu(shouldFocusOnContainer, shouldFocusOnMount);
            }
        };
        _this.dismissMenu = function () {
            if (_this.button.current) {
                _this.button.current.dismissMenu();
            }
        };
        _this.focus = function () {
            _this.button.current && _this.button.current.focus();
        };
        _this.getInputMethod = function (ev) {
            var inputMethod = _this.pointerInputMethod;
            // if inputMethod is not Touch or Pen and we have a mouse event, lets attempt to get
            // the input method from event instead of the pointer.  In cases where the event is undefined
            // we will always use pointer.  For example, flyout anchors don't pass an event.
            // However, IE will have ev.native always as 0 which will make us set
            // inputMethod for clicks to Keyboard, we know this is a mouse click so lets just return
            // the correct inputMethod
            if (ev &&
                inputMethod !== InputMethod.Pen &&
                inputMethod !== InputMethod.Touch &&
                !(isIE() && inputMethod === InputMethod.Mouse)) {
                inputMethod = getInputMethodFromEvent(ev);
            }
            _this.pointerInputMethod = undefined;
            return inputMethod;
        };
        _this.onMouseDown = function (ev) {
            if (_this.props.onMouseDown) {
                _this.props.onMouseDown(ev);
            }
            if (!_this.props.takeFocusOnClick) {
                ev.preventDefault();
            }
        };
        _this.onPointerDown = function (ev) {
            _this.pointerDownEventId = ev.pointerId;
        };
        _this.onPointerUp = function (ev) {
            if (_this.pointerDownEventId === ev.pointerId) {
                switch (ev.pointerType) {
                    case 'touch':
                        _this.pointerInputMethod = InputMethod.Touch;
                        break;
                    case 'pen':
                        _this.pointerInputMethod = InputMethod.Pen;
                        break;
                    case 'mouse':
                        _this.pointerInputMethod = InputMethod.Mouse;
                        break;
                    default:
                        _this.pointerInputMethod = InputMethod.Unknown;
                }
            }
            _this.pointerDownEventId = undefined;
        };
        return _this;
    }
    AppBaseButton.prototype.render = function () {
        var _this = this;
        return (React.createElement(AppThemeConsumer, null, function (theme) { return (React.createElement(BaseButton, __assign({}, _this.props, { componentRef: _this.button, onMouseDown: _this.onMouseDown, styles: getAppBaseButtonStyles(theme, _this.props.styles, _this.props.iconProps !== undefined), allowDisabledFocus: true, onPointerDown: _this.onPointerDown, onPointerUp: _this.onPointerUp }))); }));
    };
    return AppBaseButton;
}(React.PureComponent));
export { AppBaseButton };
//# sourceMappingURL=AppBaseButton.js.map